import { dunes, heatwave } from 'athena/styles/colors';
import { MentoringProgramMatchingType } from 'redux/schemas/models/mentoring-programs';

export const MATCHING_TYPE_COLORS = {
  [MentoringProgramMatchingType.PARTICIPANT_DRIVEN]:
    `linear-gradient(45deg, ${dunes} 0%, ${heatwave} 100%)`,
  [MentoringProgramMatchingType.AUTOMATED_MATCHING]:
    'linear-gradient(48.41deg, #60F3AB 0%, #00CCBC 45%, #009AC0 100%)',
};
